"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ApartmentDescription_1 = __importDefault(require("../ApartmentDescription"));
var ShortInfo_1 = __importDefault(require("../PostContentWrapper/ShortInfo"));
var ApartmentInfo_1 = __importDefault(require("./ApartmentInfo"));
var ApartmentInfoSection = function (_a) {
    var postData = _a.postData, isRent = _a.isRent;
    return (react_1.default.createElement("div", { className: "section-data" },
        react_1.default.createElement(ShortInfo_1.default, { postData: postData }),
        postData.sections.apartment_info &&
            postData.sections.apartment_info[0].description && (react_1.default.createElement(ApartmentDescription_1.default, { propertyType: postData.propertyType, postData: postData })),
        react_1.default.createElement(ApartmentInfo_1.default, { postData: postData, isRent: isRent })));
};
exports.default = ApartmentInfoSection;
